export default __webpack_public_path__ + "static/media/learose-2048w.75bc6ff3.png";